import { MessageAtachment } from '@common/ts/types';
import { motion } from 'framer-motion';
import Image from '../../Image/Image';
import ProtectedMediaWrapper from '../../media/ProtectedMediaWrapper';
import useImageViewerStore from '../../../store/ImageViewerStore';
import { useMessageImages } from '../../../contexts/MessageImagesContext';

function ImageMessage({ url, label }: MessageAtachment) {
  const { setIsViewerOpen, setCurrentImageUrl, setCurrentImageAlt, setImages, setCurrentIndex } =
    useImageViewerStore();
  const { images } = useMessageImages();

  const showImagePreview = () => {
    if (!url) return;

    setImages(images);

    const index = images.findIndex((img) => img.url === url);
    setCurrentIndex(index >= 0 ? index : 0);

    setCurrentImageUrl(url);
    setCurrentImageAlt(label || 'image preview');
    setIsViewerOpen(true);
  };

  return (
    <motion.div
      initial={{ opacity: 1, transform: 'scale(1)' }}
      whileHover={{ opacity: 0.8, transform: 'scale(1.01)' }}
      whileTap={{ transform: 'scale(0.9)' }}
      className="w-full h-full max-w-[400px]"
    >
      <ProtectedMediaWrapper onClick={showImagePreview}>
        <Image src={url} alt="" className="rounded-lg cursor-zoom-in" />
      </ProtectedMediaWrapper>
    </motion.div>
  );
}

export default ImageMessage;
